import React, { useContext } from "react";
import { TextField } from "@mui/material";
import { viewportContext } from "../../context/ViewportContext";
import styles from "../../styles.module.css";
function DateFilter({ startDate, setStartDate, endDate, setEndDate }) {
  const { screenType } = useContext(viewportContext);
  const handleStartDateChange = (event) => {
    setStartDate(event.target.value);
  };

  const handleEndDateChange = (event) => {
    setEndDate(event.target.value);
  };

  return (
    <div
      style={
        screenType.isMobile
          ? { display: "flex", flexDirection: "column", alignItems: "center" }
          : { display: "flex", alignItems: "center" }
      }
    >
      <TextField
        label="Start Date"
        type="date"
        value={startDate}
        onChange={handleStartDateChange}
        style={{
          marginRight: screenType.isMobile ? "0px" : "30px",
        }}
        className={styles.filterButtonMargin}
      />
      <TextField
        label="End Date"
        type="date"
        value={endDate}
        onChange={handleEndDateChange}
        className={styles.filterButtonMargin}
      />
    </div>
  );
}

export default DateFilter;
